import * as React from 'react';
import { Hero } from '@brightlayer-ui/react-components/core';
import { getIcon } from '../../lib/icons';
import { ChannelDatum } from '../../types';
import { getMetric } from '../../data/domain/metric-data-helpers';

export const MetricHero: React.FC<{ channelDatum: ChannelDatum; testId?: string }> = (props) => {
    const metric = getMetric(props.channelDatum);
    const TheIcon = getIcon(metric.icon, 'Clear');

    return (
        <div style={{ flex: '1 1 0px' }}>
            <Hero
                data-testid={props.testId}
                icon={
                    <TheIcon
                        fontSize="large"
                        style={metric.iconColor ? { color: metric.iconColor } : {}}
                        data-testid={`${metric.icon}-icon`}
                    />
                }
                label={metric.channelName}
                ChannelValueProps={{
                    value: metric.value ? metric.value : "",
                    units: metric.units,
                    style: { fontSize: 'initial' },
                }}
                iconSize="small"
            />
        </div>
    );
};
